module.exports = __webpack_public_path__ + "components/home-header/static/header-2--large-7bd06c4ebb7e128ef7ea9256d278bdbf.jpg";